import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const SOCIAL_LINKS = [
    {
        label: "Instagram",
        href: "https://www.instagram.com/meetwithlunar/",
        testId: "follow-instagram-link",
    },
    {
        label: "TikTok",
        href: "https://www.tiktok.com/@meetolea",
        testId: "follow-tiktok-link",
    },
];

export const Follow = () => (
    <section
        data-testid="follow-section"
        className="border-y border-[#E5E3DC] bg-[#F0EFEB]/50"
    >
        <Reveal className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-6 py-10 text-center">
            <p className="font-display text-xl font-semibold text-[#1D201A]">
                Follow the journey
            </p>
            <div className="flex flex-wrap items-center justify-center gap-3">
                {SOCIAL_LINKS.map(({ label, href, testId }) => (
                    <a
                        key={label}
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Follow Lunar on ${label}`}
                        data-testid={testId}
                        className="inline-flex items-center gap-1.5 rounded-full border border-[#D5D8CB] px-4 py-2 text-sm font-medium text-[#2C3618] transition-colors duration-200 hover:border-[#899B6A] hover:bg-[#D5D8CB]/35"
                    >
                        {label}
                        <ArrowUpRight size={14} aria-hidden="true" />
                    </a>
                ))}
            </div>
        </Reveal>
    </section>
);
